package dev.bitspittle.droidconSf24.pages.sections.kobweb.silk

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun Icons3Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/silk/Icons3.md", mapOf("styles" to listOf("accented-subheaders")))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("icons") }) {
                org.jetbrains.compose.web.dom.Text("Icons")
            }
            org.jetbrains.compose.web.dom.H3(attrs = { id("material-design") }) {
                org.jetbrains.compose.web.dom.Text("Material Design")
            }
            dev.bitspittle.droidconSf24.components.widgets.Code("""// build.gradle.kts
kotlin {
  sourceSets {
    jsMain.dependencies {
      implementation(libs.silk.icons.mdi)
    }
  }
}
""", "kotlin 5")
            dev.bitspittle.droidconSf24.components.widgets.Code("""MdiVisibility(style = IconStyle.OUTLINED)
MdiFavorite()
Text("Kobweb")
""", "kotlin <fragment>")
            org.jetbrains.compose.web.dom.P {
                com.varabyte.kobweb.compose.dom.GenericTag("span", "class=\"fragment\"") {
                    MdiVisibility(Modifier.fontSize(2.5.cssRem), style = MdiIconStyle.OUTLINED)
                    org.jetbrains.compose.web.dom.Text(" ")
                    com.varabyte.kobweb.compose.dom.GenericTag("span", "style=\"color:red\"") {
                        MdiFavorite(Modifier.fontSize(2.5.cssRem))
                    }
                    org.jetbrains.compose.web.dom.Text(" ")
                    Kobweb()
                }
            }
        }
    }
}
